import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const Knowup = ({ classes }) => {
  return (
    <div className={classes.popup}>
      <img
        src="/assets/knowup-logo-black.png"
        alt="KnowUp Logo"
        className={classes.logo}
      />
      <div className={classes.titleContainer}>
        <Typography className={classes.title}>
          Run your academy directly on Discord with the
        </Typography>
        <Typography className={classes.description}>
          KnowUp Discord App
        </Typography>
      </div>
      <a
        href="https://knowup.io/"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.button}
      >
        Go to website
      </a>
      <iframe
        className={classes.iframe}
        src="https://www.youtube.com/embed/2BsH_ZGTNFo"
        title="KnowUp Introduction"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />

      <Typography className={classes.note}>
        <span className={classes.noteTitle}>Note:</span> KnowUp is our other
        product, which is developed only for community training in Discord. Mini
        Course Generator and KnowUp are independent from each other and work as
        standalone solutions.
      </Typography>
    </div>
  )
}

export default withStyles(styles)(Knowup)
